import React, { useEffect } from 'react';
import OurCommitments from './OurCommitments'
import WhoweareBanner from './WhoweareBanner'
import AboutCompany from './AboutCompany';
import OurLeadership from './OurLeadership';
import GroupOfCompanies from './GroupOfCompanies';
//  import Testimonials from './Testimonials';
import Ab from './Ab';
const WhoweAre = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
  // Scroll to the top of the page when the component mounts
  // Related grouping of the formates and all we have to check in the really 

  return (
    <div style={{ background: '#fff' }}>
      <WhoweareBanner />

      <AboutCompany />
      {/* <Ab/> */}
      <OurCommitments />
      <OurLeadership />

      {/* all other data for />*/}
      <GroupOfCompanies />
      {/* <OurLeadership /> */}

      <br></br>

      {/* <OurLeadership/> */}
      {/* { <OurLeadership/> } */}
      {/* { <Testimonials/> } */}
      {/* <Delivery /> */}

    </div>
  )
}

export default WhoweAre